// ─── Template : CHAMP-BOUTON (ouvre un sélecteur) ─────────────────
// Champ en lecture qui ouvre une modale sœur (date 📅, heure 🕒, lieu 📍…).
//   <ChampBouton icone="🕒" valeur={heure} placeholder="—" onPress={…} />
// `enErreur` applique le style d'erreur app-wide (bord rouge) ; `estompe`
// reçoit le style de clignotement du principe « montrer les erreurs ».
import React, { useMemo } from 'react';
import { Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { styleChampErreur } from './ChampErreur';

export default function ChampBouton({ icone, valeur, placeholder = '—', onPress, enErreur, estompe, style }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <TouchableOpacity style={[s.btn, enErreur && styleChampErreur(UI), estompe, style]} onPress={onPress}>
      <Text style={[s.val, !valeur && s.vide]} numberOfLines={1}>
        {icone ? `${icone} ` : ''}{valeur || placeholder}
      </Text>
    </TouchableOpacity>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  btn: { backgroundColor: UI.card, borderWidth: 1, borderColor: UI.champBord, borderRadius: 11, paddingHorizontal: 12, paddingVertical: 10 },
  val: { fontSize: 14, color: UI.ink },
  vide: { color: UI.faint },
});
